import React from "react";

import { useSignupFormDrip } from "@sp-state/useSignupFormDrip";
import Form from "../Form";

import styles from "./FormContent.module.scss";

const FormContent = () => {
  const { getCurrentStep, getIsFirstStep, prev } = useSignupFormDrip(
    state => state
  );
  const step = getCurrentStep();
  const firstStep = getIsFirstStep();

  const handleBack = () => {
    prev();
  };

  return (
    <section className={styles.content}>
      <div>
        {!firstStep && (
          <button className={styles.backBtn} onClick={handleBack}>
            <img src="/icons/drip-form-back-arrow.svg" alt="back arrow" />
            Back
          </button>
        )}

        <h4 className={styles.headline}>{step?.headline}</h4>
        <p className={styles.subcopy}>{step?.subcopy}</p>
      </div>

      <Form />
    </section>
  );
};

export default FormContent;
